// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__E\\+nre {
  display: flex;
  gap: 16px;
}
@media (max-width: 1200px) {
  .styles_wrapper__E\\+nre {
    flex-direction: column;
  }
}

.styles_inputWrapper__lmyNl {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.styles_buttonWrapper__2flpr {
  margin-top: 8px;
  text-align: right;
}

.styles_button__wtZNd {
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: #ff136d;
}

.styles_headingWrapper__cB0JA {
  display: flex;
  justify-content: space-between;
}

.styles_heading__8mV\\+-,
.styles_valueWrapper__Y3ulG {
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.5);
}

.styles_value__zkr56 {
  color: #ffffff;
}

.styles_valueWrapper__Y3ulG {
  display: flex;
  align-items: center;
}

.styles_buttonGradientWrapper__nZdth {
  margin-top: 24px;
  width: 141px;
  height: 64px;
}
@media (max-width: 1200px) {
  .styles_buttonGradientWrapper__nZdth {
    width: 100%;
    margin-top: 0;
  }
}
@media (max-width: 768px) {
  .styles_buttonGradientWrapper__nZdth {
    height: 44px;
  }
}

.styles_error__mqaqA {
  margin-top: 8px;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: -0.015em;
  text-align: right;
  text-transform: capitalize;
  color: #d33030;
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/content/stakeBlock/inputStake/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,SAAA;AAFF;ACgBE;EDhBF;IAKI,sBAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,cEpBK;AFmBP;;AAIA;EACE,aAAA;EACA,8BAAA;AADF;;AAIA;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BEvCS;AFsCX;;AAIA;EACE,cEjDM;AFgDR;;AAIA;EACE,aAAA;EACA,mBAAA;AADF;;AAIA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;AADF;ACxCE;EDsCF;IAMI,WAAA;IACA,aAAA;EAAF;AACF;AClCE;ED0BF;IAWI,YAAA;EACF;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;EACA,0BAAA;EACA,cEhDI;AFiDN","sourcesContent":["@import './src/assets/styles/variables/colors';\n@import './src/assets/styles/mixin/breakpoints';\n\n.wrapper {\n  display: flex;\n  gap: 16px;\n\n  @include xl {\n    flex-direction: column;\n  }\n}\n\n.inputWrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.buttonWrapper {\n  margin-top: 8px;\n  text-align: right;\n}\n\n.button {\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $pink;\n}\n\n.headingWrapper {\n  display: flex;\n  justify-content: space-between;\n}\n\n.heading,\n.valueWrapper {\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-50;\n}\n\n.value {\n  color: $white;\n}\n\n.valueWrapper {\n  display: flex;\n  align-items: center;\n}\n\n.buttonGradientWrapper {\n  margin-top: 24px;\n  width: 141px;\n  height: 64px;\n\n  @include xl {\n    width: 100%;\n    margin-top: 0;\n  }\n\n  @include md {\n    height: 44px;\n  }\n}\n\n.error {\n  margin-top: 8px;\n  font-weight: 300;\n  font-size: 12px;\n  line-height: 15px;\n  letter-spacing: -0.015em;\n  text-align: right;\n  text-transform: capitalize;\n  color: $red;\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__E+nre`,
	"inputWrapper": `styles_inputWrapper__lmyNl`,
	"buttonWrapper": `styles_buttonWrapper__2flpr`,
	"button": `styles_button__wtZNd`,
	"headingWrapper": `styles_headingWrapper__cB0JA`,
	"heading": `styles_heading__8mV+-`,
	"valueWrapper": `styles_valueWrapper__Y3ulG`,
	"value": `styles_value__zkr56`,
	"buttonGradientWrapper": `styles_buttonGradientWrapper__nZdth`,
	"error": `styles_error__mqaqA`
};
export default ___CSS_LOADER_EXPORT___;
